import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import fr from 'date-fns/locale/fr';
export default function ReusableDatePicker({
  selected,
  setDateState,
  closed,
  customInput,
  maxDays = 30,
}) {


  const handleChange = (date) => {
    if (!date) return;
    const newDate = moment(date);
    setDateState({
    day: newDate,
    hourSelectValue: 0,
    isValidDate: true,
});
  };

  return (
    <div style={{ position: 'relative' }}>
      <DatePicker
        selected={selected}
        onChange={handleChange}
        customInput={customInput}
        locale={fr}
        maxDate={moment().add(maxDays, 'd').toDate()}
        disabled={closed}
        minDate={moment().toDate()}
      />
    </div>
  );
}
